import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RouteHelperService } from '@app/services';


/**
 * @deprecated Use <icon-link  [configId]="'open-listing-admin-page'" [id]="-1"></icon-link> or <icon-link  [configId]="'open-listing-admin-new-page'" [id]="-1"></icon-link> instead
 * A component that is a clickable icon for opening the admin page for a listing
 * Holding down the ctrl key will reverse the "openInNewTab" property
 * <link-to-new-admin-listing [openInNewTab]="true" [listingId]="-1"></link-to-new-admin-listing>
 */
@Component({
    selector: "link-to-new-admin-listing",
    templateUrl: "./link-to-new-admin-listing.component.html",
    styleUrls: ["./link-to-new-admin-listing.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class LinkToNewAdminListingComponent implements OnInit {
  private readonly _componentName = 'LinkToNewAdminListingComponent';

  @Input()
  public listingId: number;

  @Input()
  public openInNewTab: boolean = true;

  constructor(private routeHelper: RouteHelperService, private router: Router) {}

  ngOnInit() {}

  public onClick(e: PointerEvent) {
    console.log(`${this._componentName}.onClick e=`, e);
    e.stopPropagation();

    const path = `/landowner/listing/${this.listingId}`;

    let b = this.openInNewTab;

    if (e.ctrlKey) {
      b = !b;
    }

    if (b) {
      this.routeHelper.openRouteInNewTab(path);
    } else {
      this.router.navigate([path]);
    }
  }
}
